<template>
    <div class="wrapper-style result-wrapper rd-approach">
        <div class="fix-bg share-bg">
            <div class="bgview">
                <div class="gradient-cover"></div>
            </div>
        </div>
        <div class="page-box">
            <div class="bgview" id="rd-scroller">
                <div class="share-box" id="rd-section-1">
                    <div class="share-pic">
                        <div class="bg"></div>
                        <div class="box">
                            <div class="view">
                                <div class="img">
                                    <img :src="`${path+result.song.image_share+'.jpg'}`" alt="" v-on:click="clickPic">
                                    <button type="button" class="save-btn">長按存圖</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="share-tool">
                        <div class="view">
                            <div class="tag-show">
                                <p>往下滑看任務細節</p>
                                <p class="col-red">領按摩金、抽萬元 SPA 行程</p>
                            </div>
                            <div class="ig-tit">
                                <div class="line-left"><span></span></div>
                                <p>IG 限動分享 3 步驟</p>
                                <div class="line-right"><span></span></div>
                            </div>
                            <transition name="fade" mode="out-in">
                                <div class="pop-note" v-show="showMsg">
                                    <div class="view">
                                        <div class="bg"><p>連結已複製，到 IG 限動或 FB 分享測驗結果吧！</p></div>
                                    </div>
                                </div>
                            </transition>
                            <ul class="ul">
                                <li>
                                    <h5>Step1</h5>
                                    <p>先存圖</p>
                                </li>
                                <li>
                                    <h5>Step2</h5>
                                    <button type="button" v-on:click="copyText">點我複製連結</button>
                                </li>
                                <li>
                                    <h5>Step3</h5>
                                    <button type="button" v-on:click="openIg">打開IG限動</button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="share-funnow">
                    <div class="result-show-box">
                        <div class="wave-bg-line marb-24"></div>
                        <div class="area-box marb-24" id="rd-section-2">
                            <div class="box-view">
                                <div class="line-b"></div>
                                <div class="line-t"></div>
                                <div class="line-r"></div>
                                <div class="line-l"></div>
                                <div class="bg-t-l">
                                    <div class="bgshow"></div>
                                </div>
                                <div class="bg-t-r">
                                    <div class="bgshow"></div>
                                </div>
                                <div class="bg-b-l">
                                    <div class="bgshow"></div>
                                </div>
                                <div class="bg-b-r">
                                    <div class="bgshow"></div>
                                </div>
                                <div class="view">
                                    <div class="result-logo"></div>
                                    <h5>讓你的疲累有出口!</h5>
                                    <div class="area-tit">
                                        <div class="show">✨五一按摩節，全月送 $510 按摩金✨</div>
                                    </div>
                                    <ul class="marb-12">
                                        <li>下載 FunNow 輸入優惠碼【Dcard】 首次預訂折$150</li>
                                        <li>按完一次，送 $360 按摩金繼續按！</li>
                                    </ul>
                                    <button type="button" class="bl-btn marb-24" v-on:click="clickMassage">
                                        <span>馬上去按摩 👉🏻</span>
                                    </button>
                                    <div class="area-tit">
                                        <div class="show">下載 Dcard ，抽萬元 SPA 行程</div>
                                    </div>
                                    <ul class="marb-12">
                                        <li>新註冊秒拿 85 折按摩優惠</li>
                                        <li>下載 Dcard 留言拿 9 折按摩優惠，再抽總價萬元 SPA 行程</li>
                                        <li>詳情請看「工作板」置頂文</li>
                                    </ul>

                                    <button type="button" class="bl-btn marb-24" v-if="auth" v-on:click="clickDiscount">
                                        <span>我要抽萬元 SPA 👉🏻</span>
                                    </button>
                                    <button type="button" class="bl-btn marb-24" v-if="!auth" v-on:click="login">
                                        <span>我要抽萬元 SPA 👉🏻</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="wave-bg-line marb-24"></div>
                        <div class="show-tit" id="rd-section-3">
                            <div class="view">
                                <p>用 <span class="col-red">FunNow</span></p>
                                <p>隨時預約鬆一下</p>
                            </div>
                        </div>
                        <div class="funnow-relax marb-24">
                            <div class="hock"><div class="view"></div></div>
                            <div class="show">
                                <div class="img-box">
                                    <div class="view"></div>
                                </div>
                                <div class="microphone"></div>
                            </div>
                            <button type="button" class="red-btn marb-24" v-on:click="clickMoreDiscount">
                                <span>更多按摩優惠</span>
                            </button>
                        </div>

                        <div class="show-tit">
                            <div class="view">
                                <p>解放你的社畜魂！</p>
                                <p>加入 <span class="col-red">Dcard</span> 豐富你的下班生活</p>
                            </div>
                        </div>
                        <div class="join-dcard">
                            <div class="hock"><div class="view"></div></div>
                            <div class="show">
                                <div class="img-box">
                                    <div class="view"></div>
                                </div>
                                <div class="microphone"></div>
                            </div>
                            <button type="button" class="red-btn" v-on:click="clickDownload">
                                <span>立即下載</span>
                            </button>
                        </div>
                    </div>
                    <div class="copyright">
                        <p>Copyright © 2023 Dcard Holdings Ltd.</p>
                        <p>All Rights Reserved.</p>
                    </div>
                </div>

            </div>
        </div>
    </div>


</template>

<script>


export default {
    name:"Share",
    props: ["result", "path", "uid", "auth"],
    data() {
        return {
            showMsg: false,
            isMobile: false
        }
    },
    created() {

    },
    methods: {
        copyText: function () {
            this.$gtag.event('click_copy_link')
            this.$gtag.event(this.result.data.ga.click_copy_link)

            let link = process.env.MIX_APP_URL+'/' +this.result.data.en_name+'-'+(this.result.index+1)

            const queryString = window.location.search
            let urlParams = new URLSearchParams(queryString)

            urlParams.set('utm_source', 'result_pic_page')
            urlParams.set('utm_medium', 'copy_link')
            urlParams.set('utm_campaign', 'massage')

            navigator.clipboard.writeText(link+"?"+ urlParams.toString());
            this.showCopyMsg()
        },
        showCopyMsg: function () {
            const _this = this
            _this.showMsg = true;
            setTimeout(function () {
                _this.showMsg = false;
            }, 3000)
        },
        clickPic: function (){
            this.$gtag.event('click_save_pic')
            this.$gtag.event(this.result.data.ga.click_save_pic)
        },
        openIg: function () {

            this.$gtag.event('click_ig_story')
            this.$gtag.event(this.result.data.ga.click_ig_story)

            if(this.isMobile){
                window.open('instagram://story-camera')
            }else{
                window.open('https://www.instagram.com')
            }
        },
        clickMassage(){
            this.$gtag.event('click_result_pic_funnow')
            this.$gtag.event(this.result.data.ga.click_result_pic_funnow)
            window.open("https://funnow.page.link/2023MSG_Dcard_Test")
        },
        clickDiscount(){
            this.$gtag.event('click_result_pic_dcard')
            this.$gtag.event(this.result.data.ga.click_result_pic_dcard)
            window.open("https://dcard.onelink.me/TOtb/2uxsnkoy")
        },
        clickMoreDiscount(){
            this.$gtag.event('click_result_pic_massage')
            this.$gtag.event(this.result.data.ga.click_result_pic_massage)
            window.open("https://eme2c.app.goo.gl/2023MSG_Dcard_ReadMore")
        },
        clickDownload(){
            this.$gtag.event('click_result_pic_donwload')
            this.$gtag.event(this.result.data.ga.click_result_pic_donwload)
            window.open("https://dcard.onelink.me/TOtb/2uxsnkoy")
        },
        scrollEvent(){
            const _this = this
            ScrollTrigger.create({
                scroller: "#rd-scroller",
                trigger: "#rd-section-1",
                start: "top-=30% top",
                markers:false,
                onEnter: function () {
                    _this.$gtag.event('view_result_pic_firstscreen')
                }
            });
            ScrollTrigger.create({
                scroller: "#rd-scroller",
                trigger: "#rd-section-2",
                start: "top-=30% top",
                markers:true,
                onEnter: function () {
                    _this.$gtag.event('view_result_pic_secendscreen')
                }
            });
            ScrollTrigger.create({
                scroller: "#rd-scroller",
                trigger: "#rd-section-3",
                start: "top-=30% top",
                markers:false,
                onEnter: function () {
                    _this.$gtag.event('view_result_pic_thirdscreen')
                }
            });
        }
    },
    mounted: function () {
        const _this = this
        _this.$gtag.event('view_result_pic',{member_id:_this.uid})
        _this.$gtag.event(_this.result.data.ga.view_result_pic,{member_id:_this.uid})

        this.$emit('approach-animate')

        this.isMobile = !!window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);

        window.onpopstate = function() {
            _this.$emit('switch-component', 'result-part')
        };
    }
}
</script>
<style scoped lang="scss">
.fade-enter-active, .fade-leave-active {
    transition: opacity .5s ease;
}
.fade-enter, .fade-leave-to {
    opacity: 0;
}
</style>
